import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "@angular/fire/database";
import { AngularFirestore } from "@angular/fire/firestore";
import { FileItem } from "../models/entities/file-item";
// import * as firebase from "firebase";
import * as firebase from "firebase/app";
import { Observable } from "rxjs";
import { database } from "firebase";
import { map } from "rxjs/operators";
import { ArchivoPDF } from "../models/entities/archivoPdf";
import { Alert } from "../models/alert";

@Injectable({
  providedIn: "root",
})
export class ArchivosWebService {
  private CARPETA_FICHA = "archivosWeb";
  private CARPETA_EJECUTIVA = "archivosCarpetaEjecutiva";
  alerta: Alert = new Alert();

  constructor(
    private db: AngularFirestore,
    public angularFireDatabase: AngularFireDatabase
  ) {}

  getPdf(obraKey: string): Observable<any> {
    // tslint:disable-next-line: max-line-length
    return this.angularFireDatabase
      .list<any>(this.CARPETA_FICHA, (ref: database.Reference) =>
        ref.orderByChild("keyLevantamientoObra").equalTo(obraKey)
      )
      .snapshotChanges()
      .pipe(
        map((actions) =>
          actions.map((action) => {
            const key = action.payload.key;
            const data = action.payload.val();
            return { key, ...data };
          })
        )
      );
  }

  /** Metodo utilizado para obtener las fichas segun el estado seleccionado */
  public findByKeyEstado(keyCatEstado: string): Observable<any[]> {
    return this.angularFireDatabase
      .list<any>(this.CARPETA_EJECUTIVA, (ref: database.Reference) =>
        ref.orderByChild("estado").equalTo(keyCatEstado)
      )
      .snapshotChanges()
      .pipe(
        map((changes) =>
          changes.map(
            (c) =>
              ({
                key: c.payload.key,
                ...c.payload.val(),
              } as any)
          )
        )
      );
  }

  validarNombreArchivo(nombre: string, obraKey: string): Observable<any> {
    // tslint:disable-next-line: max-line-length
    return this.angularFireDatabase
      .list<any>(this.CARPETA_FICHA, (ref: database.Reference) =>
        ref.orderByChild("nombre").equalTo(nombre)
      )
      .snapshotChanges()
      .pipe(
        map((actions) =>
          actions.map((action) => {
            const key = action.payload.key;
            const data = action.payload.val();
            return { key, ...data };
          })
        )
      );
  }

  validarNombreArchivo2(nombre: string): Observable<any> {
    // tslint:disable-next-line: max-line-length
    return this.angularFireDatabase
      .list<any>(this.CARPETA_EJECUTIVA, (ref: database.Reference) =>
        ref.orderByChild("nombre").equalTo(nombre)
      )
      .snapshotChanges()
      .pipe(
        map((actions) =>
          actions.map((action) => {
            const key = action.payload.key;
            const data = action.payload.val();
            return { key, ...data };
          })
        )
      );
  }

  cargarArchivoFirebase(archivos: FileItem[], keyObra: string) {
    const storageRef = firebase.storage().ref();

    for (const item of archivos) {
      item.estaSubiendo = true;
      if (item.progreso >= 100) {
        continue;
      }
      const uploadTask: firebase.storage.UploadTask = storageRef
        .child(`${this.CARPETA_FICHA}/${keyObra}/${item.nombreArchivo}`)
        .put(item.archivo);

      uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED,
        (snapshot: firebase.storage.UploadTaskSnapshot) => {
          item.progreso =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          // console.log(item);
        },
        (error) => {
          console.error("Error al subir a FireBase", error);
        },
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            // console.log("File available at", downloadURL);
            item.url = downloadURL;
            item.estaSubiendo = false;
            item.keyLevantamientoObra = keyObra;
            this.guardarFicha({
              nombre: item.nombreArchivo,
              url: item.url,
              keyLevantamientoObra: keyObra,
              fechaSubida: item.fechaSubida,
            });
          });
        }
      );
    }
  }

  cargarArchivoCarpetaEjecutiva(
    archivos: FileItem[],
    tipoObra: string,
    estado: string
  ) {
    const storageRef = firebase.storage().ref();

    for (const item of archivos) {
      item.estaSubiendo = true;
      if (item.progreso >= 100) {
        continue;
      }
      const uploadTask: firebase.storage.UploadTask = storageRef
        .child(`${this.CARPETA_EJECUTIVA}/${item.nombreArchivo}`)
        .put(item.archivo);

      uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED,
        (snapshot: firebase.storage.UploadTaskSnapshot) => {
          item.progreso =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          // console.log(item);
        },
        (error) => {
          console.error("Error al subir a FireBase", error);
          this.alerta.errorCustom(error.message);
        },
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            // console.log("File available at", downloadURL);
            item.url = downloadURL;
            item.estaSubiendo = false;
            this.guardarFicha2({
              nombre: item.nombreArchivo,
              url: item.url,
              tipoObra: tipoObra,
              estado: estado,
              fechaSubida: item.fechaSubida,
            });
          });
        }
      );
    }
  }

  guardarFicha(ficha: {
    nombre: string;
    url: string;
    keyLevantamientoObra: string;
    fechaSubida: number;
  }) {
    this.angularFireDatabase.list<any>(this.CARPETA_FICHA).push(ficha);
  }

  guardarFicha2(ficha: {
    nombre: string;
    url: string;
    tipoObra: string;
    estado: string;
    fechaSubida: number;
  }) {
    this.angularFireDatabase.list<any>(this.CARPETA_EJECUTIVA).push(ficha);
  }

  deleteFileDatabase(key: string) {
    return this.angularFireDatabase
      .list<ArchivoPDF>(this.CARPETA_FICHA)
      .remove(key);
  }

  deleteFileStorage(name: string, keyObra: string) {
    const storageRef = firebase.storage().ref();
    storageRef.child(`${this.CARPETA_FICHA}/${keyObra}/${name}`).delete();
  }

  deleteFileDatabase2(key: string) {
    return this.angularFireDatabase
      .list<ArchivoPDF>(this.CARPETA_EJECUTIVA)
      .remove(key);
  }

  deleteFileStorage2(name: string) {
    const storageRef = firebase.storage().ref();
    storageRef.child(`${this.CARPETA_EJECUTIVA}/${name}`).delete();
  }
}
